/**
 * Tiny session-scoped lookup cache for Products + Brands-by-product.
 *
 * Caches survive within the SPA session; cleared on signOut via
 * registerSignOutCallback. No library; just module state.
 */
import { apiAdmin } from './admin';
import type { BrandDto, ProductDto } from './types';

let productsPromise: Promise<ProductDto[]> | null = null;
const brandsByProduct = new Map<number, Promise<BrandDto[]>>();

export async function getProducts(): Promise<ProductDto[]> {
  if (!productsPromise) {
    productsPromise = apiAdmin.products.list().catch((err) => {
      productsPromise = null;
      throw err;
    });
  }
  return productsPromise;
}

export async function getBrandsByProduct(productId: number): Promise<BrandDto[]> {
  let existing = brandsByProduct.get(productId);
  if (!existing) {
    existing = apiAdmin.brands.list(productId).catch((err) => {
      brandsByProduct.delete(productId);
      throw err;
    });
    brandsByProduct.set(productId, existing);
  }
  return existing;
}

export function invalidateBrandsForProduct(productId: number): void {
  brandsByProduct.delete(productId);
}

export function invalidateAllBrands(): void {
  brandsByProduct.clear();
}

export function clearLookupCache(): void {
  productsPromise = null;
  brandsByProduct.clear();
}
